import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Card,
  CardContent,
  Chip,
} from '@mui/material';
import {
  CalendarMonth,
  People,
  QrCode,
  WhatsApp,
} from '@mui/icons-material';
import { Style } from './Style';

const WhatWeDo = () => {
  return (
    <Box id="services" sx={{ py: 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
          gutterBottom
          sx={{
            ...Style.commonHeading
          }}
        >
          What We Do
        </Typography>

        <Typography
          variant="h6"
          textAlign="center"
          sx={{
          ...Style.commonTextForwhatwedo
          }}
        >
          We provide a streamlined appointment booking service that helps you secure
          a slot at clinics, beauty parlors, and salons.
        </Typography>

        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <Card
              elevation={4}
              sx={{
              ...Style.BackGroundColorWhatWeDo1
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <CalendarMonth sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h4" gutterBottom fontWeight="bold">
                  Slot Booking
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
                  Reserve your preferred time in advance to guarantee your appointment
                  and avoid waiting. Plan your schedule with confidence.
                </Typography>
                <Chip
                  label="Guaranteed Appointment"
                  sx={{
                 ...Style.commonChipSlotBooking
                  }}
                />
              </CardContent>
            </Card>
          </Grid>

          <Grid item xs={12} md={6}>
            <Card
              elevation={4}
              sx={{
             ...Style.commonBoxWalk
              }}
            >
              <CardContent sx={{ p: 4 }}>
                <People sx={{ fontSize: 60, mb: 2 }} />
                <Typography variant="h4" gutterBottom fontWeight="bold">
                  Walk-in Management
                </Typography>
                <Typography variant="body1" sx={{ mb: 3, opacity: 0.9 }}>
                  Check for immediate availability and join a virtual queue, so you can
                  see a provider without the uncertainty of traditional walk-ins.
                </Typography>
                <Chip
                  label="Virtual Queue"
                  sx={{
                    ...Style.commonChipSlotBooking
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{...Style.commonHeading}}
          >
            Easy Booking Methods
          </Typography>

          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
              ...Style.BookingMethodBox1
                }}
              >
                <QrCode sx={{ fontSize: 50, mb: 2, color: 'primary.main' }} />
                <Typography variant="h6" fontWeight="bold">
                  QR Code
                </Typography>
                <Typography variant="body2">
                  Quick and simple booking
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                ...Style.BokkingMethosBox2
                }}
              >
                <WhatsApp sx={{ fontSize: 50, mb: 2, color: 'success.main' }} />
                <Typography variant="h6" fontWeight="bold">
                  WhatsApp
                </Typography>
                <Typography variant="body2">
                  Book directly through chat
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <Box
                sx={{
                 ...Style.BookingMethodBox3
                }}
              >
                <CalendarMonth sx={{ fontSize: 50, mb: 2, color: 'secondary.main' }} />
                <Typography variant="h6" fontWeight="bold">
                  Mobile App
                </Typography>
                <Typography variant="body2">
                  Download from Play Store
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default WhatWeDo;

